import { render, staticRenderFns } from "./ComponentIndexHealth.vue?vue&type=template&id=aaa534a0"
import script from "./ComponentIndexHealth.vue?vue&type=script&lang=js"
export * from "./ComponentIndexHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports